// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__wkT_r","crumb":"Breadcrumbs_crumb__VGnX5","link":"Breadcrumbs_link__klaZN","current-page":"Breadcrumbs_current-page__XzqYA"};